import { render, staticRenderFns } from "./ordersNew.vue?vue&type=template&id=3e40d44e&scoped=true"
import script from "./ordersNew.vue?vue&type=script&lang=js"
export * from "./ordersNew.vue?vue&type=script&lang=js"
import style0 from "./ordersNew.vue?vue&type=style&index=0&id=3e40d44e&prod&scoped=true&lang=scss"
import style1 from "./ordersNew.vue?vue&type=style&index=1&id=3e40d44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40d44e",
  null
  
)

export default component.exports